/**
 * LogPanel.tsx
 * Shows execution logs.
 */
import { useEffect, useRef } from 'react';

type LogPanelProps = {
  logs: string[];
  onClearLogs?: () => void;
};

export function LogPanel({ logs, onClearLogs }: LogPanelProps) {
  const preRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    const el = preRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="flex h-full flex-col bg-background">
      <div className="flex items-center justify-between gap-3 border-b border-border bg-muted/60 px-4 py-2">
        <h2 className="text-base font-semibold text-slate-700">ログ</h2>
        {onClearLogs && (
          <button
            type="button"
            onClick={onClearLogs}
            className="rounded border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600 transition-colors hover:bg-slate-50"
          >
            ログクリア
          </button>
        )}
      </div>
      <pre ref={preRef} className="flex-1 overflow-auto whitespace-pre-wrap bg-slate-950 p-4 font-mono text-sm leading-relaxed text-slate-100">
        {logs.length === 0 ? (
          <span className="text-slate-400">
            「実行」ボタンを押すと結果がここに表示されます
          </span>
        ) : (
          logs.join('\n')
        )}
      </pre>
    </div>
  );
}
